import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list (params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        },
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };

    return axios.get(`${url}/staffs`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function get (id) {
    let options;
    let idType = typeof(id);
    if (idType !== 'object') {
        options = {
            headers: {
                'Accept': 'application/vnd.api+json',
                'Content-Type': 'application/vnd.api+json',
            }
        };
    } else {
        options = {
            headers: {
                'Accept': 'application/vnd.api+json',
                'Content-Type': 'application/vnd.api+json',
            },
            params: id,
            paramsSerializer: function (params) {
                return qs.stringify(params, { encode: false });
            },
        };
        id = id.id;
        delete id.id;
    }

    return axios.get(`${url}/staffs/${id}`, options)
        .then(response => {
            let staff = jsona.deserialize(response.data);
            delete staff.links;
            return staff;
        });
}


function show (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/staffs/${id}`, options)
        .then(response => {
            let staff = jsona.deserialize(response.data);
            delete staff.links;
            return staff;
        });
}

function add (staff) {
    const payload = jsona.serialize({
        stuff: staff,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/staffs`, payload, options)
        .then(response => {
            let staff = jsona.deserialize(response.data);
            delete staff.links;
            return staff;
        });
}

function update (staff) {
    const payload = jsona.serialize({
        stuff: staff,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/staffs/${staff.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/staffs/${id}`, options);
}

function upload (staff) {
    const  model_path = 'App\\Models\\Guidance\\';
    const bodyFormData = new FormData();
    bodyFormData.append('modal_name', 'Staff');
    bodyFormData.append('resource','staffs');
    bodyFormData.append('id', staff.id);
    bodyFormData.append('modal_path', model_path);
    console.log('kileo was here in upload');
    console.log(bodyFormData);
    console.log(staff);
    return axios.post(`${url}/create_account/users`, bodyFormData)
        .then(response => {
            return response.data;
        });
}
export default {
    list,
    get,
    upload,
    show,
    add,
    update,
    destroy
};

